import React from "react";
//Mis componentes

import { AppRouter } from "./router/AppRouter";


function App () {
  return(
    <>
      <AppRouter></AppRouter>
    </>
  );
}

export default App